import lozad from 'lozad'
export const ajaxLoadMore = {
	appendAjax: function () {
		$('.ajaxResponseWrap').append('<div class="loading-ajax"></div>')
	},
	processAjax: function (pageUrl) {
		const observer = lozad()
		$.ajax({
			type: 'GET',
			url: pageUrl,
			dataType: 'html',
			beforeSend: function () {
				$('.loading-ajax').addClass('active')
			},
			success: function (data) {
				$('.ajaxResponse').html(
					$(data).find('.ajaxResponse').html()
				)
				// Check Pagination exists ?
				if ($(data).find('.pagination li:last-child').hasClass('disabled')) {
					$('.btn-show-more').remove();
				} else {
					$('.pagination').html($(data).find('pagination').html());
				}
			},
			complete: function (data) {
				$('.loading-ajax').removeClass('active')
				if (pageUrl != window.location) {
					window.history.pushState({path: pageUrl}, '', pageUrl)
				}
				observer.observe();
			},
		})
	},
	handleLoadMore: function () {
		const self = this;
		$('.btn-show-more').on('click', function (e) {
			e.preventDefault()
			const linkNext = $('.pagination li:last-child a').attr('href');
			console.log("🚀 ~ file: ajaxLoadMore.js:37 ~ linkNext:", linkNext)
			self.processAjax(linkNext) // How to use function processAjax in scope ajaxLoadMore
		})
	},
	init: function () {
		ajaxLoadMore.appendAjax()
		ajaxLoadMore.handleLoadMore()
	},
}
